<template>
  <CongrModal :visible="visible" @close="handleClose">
    <div class="winContent">
      <div class="title">恭喜你获得</div>
      <div class="awardName">价值{{ awardTotalValue | centToYuan }}元礼包</div>
      <div class="singleAwardImg">
        <Award :awardData="awardData" />
      </div>
      <div class="note">以上奖励已放入【我的奖励】</div>
      <div class="okBtn" @click="handleClickOk">
        再次发起助力领券
        <div class="badge">{{ badgeStr }}</div>
      </div>
    </div>
  </CongrModal>
</template>

<script>
import CongrModal from './CongrModal';
import Award from '@/components/templates/common/awardItem/Award';
import { centToYuan } from '@/components/templates/helper';

export default {
  components: { CongrModal, Award },
  data() {
    return {
      awardData: {
        rewardType: 'REWARD_PACKAGE'
      }
    };
  },
  watch: {
    visible: function(newVal, oldVal) {
      if (newVal && !oldVal) {
        // 埋点
        this.reportExpo();
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    awardTotalValue: {
      type: Number,
      require: true
    },
    badgeStr: {
      type: String,
      require: true
    }
  },
  filters: { centToYuan },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleClickOk() {
      this.$emit('relaunch');
      this.$emit('close');
      this.$emit('reportEvent', {
        event: 'boost_coupon_popup_invite_click',
        module_name: '助力成功弹窗',
        button_name: '再次发起助力领券'
      });
    },
    reportExpo() {
      this.$emit('reportExpoEvent', {
        event: 'boost_coupon_invite_expo',
        module_name: '助力成功弹窗'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.winContent {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-size: 40px;
    color: #333;
  }

  .awardName {
    margin: 20px auto 30px;
    width: 478px;
    font-size: 40px;
    color: #ff6600;
  }

  .singleAwardImg {
    width: 280px;
    height: 280px;
    font-size: 50px;
  }

  .note {
    margin-top: 50px;
    font-size: 28px;
    color: #a0a0a0;
  }

  .okBtn {
    position: relative;
    margin-top: 40px;
    margin-bottom: 50px;
    width: 450px;
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: normal;
    border-radius: 44px;
    font-size: 40px;
    color: #fff;
    background: linear-gradient(to top, #ff0044 0%, #ff4153 38%, #fd515f 99%);

    .badge {
      position: absolute;
      top: -30px;
      left: 290px;
      width: 200px;
      height: 44px;
      font-size: 26px;
      color: #ff264b;
      .fc;
      line-height: normal;
      background: center / cover no-repeat
        url('../assets/images/modal-tag-bg.png');
    }
  }
}
</style>
